import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { getRoute } from '@/router/paths';

const useStyles = makeStyles((theme) => ({
  logoBox: {
    display: 'flex',
    flex: 1,
  },
  logo: {
    display: 'block',
  },
  header: {
    boxShadow: ({ elevation }) => theme.shadows[elevation],
    [theme.breakpoints.up('lg')]: {
      width: `100%`,
    },
  },
  toolbar: {
    color: theme.palette.common.white,
  },
  menuButton: {
    marginRight: theme.spacing(3.5),
  },
  appBar: {
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
  },
}));

function HeaderLanding() {
  const classes = useStyles();
  const logo = getRoute('/images/logo-white/logo');

  return (
    <AppBar position="sticky" color="secondary" className={classes.header}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.logoBox}>
          <img
            className={classes.logo}
            width="150"
            height="24"
            srcSet={`
                ${logo}.png 1x,
                ${logo}@2x.png 2x
              `}
            src={`${logo}.png`}
            alt="Payconiq logo"
          />{' '}
        </div>
      </Toolbar>
    </AppBar>
  );
}

HeaderLanding.defaultProps = {
  elevation: 1,
};

export default HeaderLanding;
